import React from "react";

import Grid from "@material-ui/core/Grid";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import PanelEventsContainer from "../panel-events-container";
import PanelInstrumentContainer from "../panel-instrument-container";
import PanelTableContainer from "../panel-table-container";
import TrendGraphContainer from "../trend-graph-container";

import PanelStatisticsContainer from "../panel-statistics-container";
import PanelVirtualInstrumentsContainer from "../panel-virtual-instruments-container";

import { viewVar } from "../../../reactive-variables";
import { useReactiveQueryParam } from "../../../use-reactive-query-params";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
}

function OverviewPanel(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    // panelName,
    panelDefinition,
  } = props;
  // const classes = useStyles(props);
  // const { intl /*, logo, logoText, routes*/ } = props;

  // const [activeViewTab, setActiveViewTab] = useState(0);
  const viewReactiveVar = useReactiveQueryParam("view", viewVar);

  const overviewTabs: any[] = [];
  // if (showTableLink) {
  overviewTabs.push({
    id: "table",
    key: "uiOverviewShowTable",
    label: "Table & Graph",
  });
  // }
  // if (showViLink) {
  overviewTabs.push({
    id: "vi",
    key: "uiOverviewShowVIs",
    label: "Instruments",
  });
  // }
  // if (showStatistic) {
  overviewTabs.push({
    id: "statistic",
    key: "uiOverviewShowStatistics",
    label: "Statistics",
  });
  // }

  const handleViewTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    // setActiveViewTab(newValue);
    viewReactiveVar(overviewTabs[newValue].id);
  };

  let activeViewTab = overviewTabs.findIndex(
    (tab: any) => tab.id === viewReactiveVar()
  );
  activeViewTab = Math.max(0, activeViewTab);
  const viewTab = overviewTabs[activeViewTab];

  return (
    <>
      <Tabs
        value={activeViewTab}
        onChange={handleViewTabChange}
        // textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {overviewTabs.map((tab: any) => (
          <Tab key={tab.id} label={tab.label} />
        ))}
      </Tabs>
      <Grid container spacing={1} justify="center" alignItems="center">
        {viewTab.id === "table" && (
          <>
            <Grid
              item
              xs={6}
              md={2}
              container
              justify="center"
              alignItems="flex-start"
            >
              <PanelInstrumentContainer
                nodes={nodes}
                panelCollectionName={panelCollectionName}
                panelDefinition={panelDefinition}
              />
            </Grid>
            <Grid item xs={12} md={10}>
              <PanelTableContainer
                nodes={nodes}
                panelCollectionName={panelCollectionName}
                panelDefinition={panelDefinition}
              />
            </Grid>
            <Grid item xs={12}>
              <TrendGraphContainer
                nodes={nodes}
                panelCollectionName={panelCollectionName}
                // panelName={panelName} // TODO
                panelDefinition={panelDefinition}
                // startDate={moment().startOf("day").unix()}
                // endDate={moment().endOf("day").unix()}
              />
            </Grid>
            <Grid item xs={12}>
              <PanelEventsContainer
                nodes={nodes}
                panelCollectionName={panelCollectionName}
                panelDefinition={panelDefinition}
                // startDate={moment().startOf("day").unix()}
                // endDate={moment().endOf("day").unix()}
              />
            </Grid>
          </>
        )}
        {viewTab.id === "vi" && (
          <Grid item xs={12}>
            <PanelVirtualInstrumentsContainer
              nodes={nodes}
              panelCollectionName={panelCollectionName}
              panelDefinition={panelDefinition}
            />
          </Grid>
        )}
        {viewTab.id === "statistic" && (
          <Grid item xs={12}>
            <PanelStatisticsContainer
              nodes={nodes}
              panelCollectionName={panelCollectionName}
              panelDefinition={panelDefinition}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default OverviewPanel;
